@if (vm$ | async; as vm) {
<div class="ready-board internal-board">
    <header class="board-header">
        <div class="brand">
            <div class="title">
                <img src="assets/img/logo-dark.png" alt="Eugov" class="brand-logo" />

            </div>
        </div>
        <div class="clock">
            <div class="time">{{ vm.time }}</div>
            <div class="date">{{ vm.date }}</div>
        </div>
    </header>

    <main class="board-main">
        <!-- Left Column: Present Children -->
        <section class="panel present-children">
            <div class="panel-title">COPII PREZENȚI ÎN INCINTĂ</div>
            <div class="scroll-container">
                @if (vm.presentChildren.length) {
                <ul class="children-list"
                    [attr.data-cols]="vm.presentChildren.length <= 4 ? '2' : vm.presentChildren.length <= 9 ? '3' : '4'">
                    @for (child of vm.presentChildren; track child.id) {
                    <li class="child-item"
                        [class.pickup-ready]="child.pickupStatus === 'READY_PICKUP'"
                        [class.pickup-preparing]="child.pickupStatus === 'PREPARING_PICKUP'">
                        <div class="child-photo-wrap">
                          <img
                            class="child-photo"
                            [src]="child.photoUrl || 'assets/img/default-child-avatar.svg'"
                            [alt]="child.name"
                            (error)="$any($event.target).src='assets/img/default-child-avatar.svg'"
                          />
                          @if (child.cameraWatchers.length) {
                          <div class="live-watch-badge" role="status" aria-label="Urmărit live pe cameră">
                            <span class="pulse-ring" aria-hidden="true"></span>
                            <span class="dot" aria-hidden="true"></span>
                          </div>
                          }
                        </div>
                        <div class="child-main">
                          <span class="name">{{ child.name }}</span>
                        </div>
                        @if (child.pickupStatus) {
                        <div class="pickup-badge">
                          {{ child.pickupStatus === 'READY_PICKUP' ? '✓ GATA DE PLECARE' : '⟳ SE PREGĂTEȘTE' }}
                        </div>
                        }
                    </li>
                    }
                </ul>
                } @else {
                <div class="empty-state">Nu sunt copii marcați prezenți.</div>
                }
            </div>
        </section>

        <!-- Right Column: Info & Schedule -->
        <div class="right-column">
            <!-- Announcements -->
            <section class="panel announcements internal">
                <div class="panel-title">ANUNȚURI INTERNE</div>
                <ul class="announcement-list">
                    @for (item of vm.internalAnnouncements; track $index) {
                    <li [ngClass]="item.type.toLowerCase()">
                        <div class="icon-wrapper">
                            <span class="icon" aria-hidden="true"></span>
                        </div>
                        <span class="text">{{ item.text }}</span>
                    </li>
                    }
                    @if (!vm.internalAnnouncements.length) {
                    <li class="empty">Nu sunt anunțuri interne.</li>
                    }
                </ul>
            </section>

            <!-- Live Camera Watchers -->
            <section class="panel live-watchers" [class.live-active]="vm.liveWatchNotices.length">
                <div class="panel-title">PĂRINȚI CONECTAȚI LIVE</div>
                <ul class="live-watch-list">
                    @for (notice of vm.liveWatchNotices; track $index) {
                    <li>
                        <span class="dot" aria-hidden="true"></span>
                        <span class="child">{{ notice.childName }}</span>
                        <span class="sep">·</span>
                        <span class="camera">{{ notice.cameraLabel }}</span>
                        @if (notice.viewerName) {
                        <span class="viewer">({{ notice.viewerName }})</span>
                        }
                    </li>
                    }
                    @if (!vm.liveWatchNotices.length) {
                    <li class="empty">Niciun părinte conectat momentan.</li>
                    }
                </ul>
            </section>

            <!-- Full Schedule -->
            <section class="panel schedule full-schedule">
                <div class="panel-title">PROGRAMUL ZILEI</div>
                <div class="schedule-list">
                    @for (item of vm.schedule; track $index) {
                    <div class="schedule-row">
                        <span class="time">{{ item.time }}</span>
                        <span class="separator">—</span>
                        <span class="activity">{{ item.label }}</span>
                    </div>
                    }
                    @if (!vm.schedule.length) {
                    <div class="empty">Nu este setat un program.</div>
                    }
                </div>
            </section>
        </div>
    </main>

    <footer class="board-footer">
        <div class="ticker">
            <div class="ticker-track">
                <span>{{ vm.state.tickerText || 'Sistem funcțional.' }}</span>
                <span aria-hidden="true">{{ vm.state.tickerText || 'Sistem funcțional.' }}</span>
            </div>
        </div>
        <div class="status-pill" [class.degraded]="vm.connectionIndicator.tone === 'degraded'"
            [class.demo]="vm.connectionIndicator.tone === 'demo'">
            <span class="dot"></span>
            <span class="text">{{ vm.connectionIndicator.label }}</span>
        </div>
    </footer>
</div>
}